import { IApplicationState } from '../../types/redux';

export function getPhone(state: IApplicationState) {
  return state.specialPromosBlocks.phone;
}
